export default __webpack_public_path__ + "static/Hero_01_Welcome-944b5334adbdaa8268075dad34560008.jpg";